const variableStore = {
  namespaced: true,

  state: {
    UA: navigator.userAgent.toLowerCase(),
    isNotch: false
  },

  getters: {
    isNative: (state) => {
      return state.UA.includes('native')
    },

    isIos: (state) => {
      return state.UA.includes('native') && state.UA.includes('ios')
    },

    isAos: (state) => {
      return state.UA.includes('native') && state.UA.includes('aos')
    }
  },

  mutations: {
    setIsNotch: (state, payload) => {
      state.isNotch = payload
    }
  }
}

export default variableStore
